var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isPushed)?_c('van-tag',{attrs:{"type":"primary","size":"medium"}},[_vm._v("已推送")]):_c('van-tag',{attrs:{"type":"warning","size":"medium"}},[_vm._v("未推送")])}
var staticRenderFns = []

export { render, staticRenderFns }